<template>
  <Modal
    hide-close-button
    :modal-style="{ minWidth: '300px', width: '300px' }"
    :title="title"
  >
    <FormWrapper @submit="onSubmit">
      <div class="q-gutter-md">
        <InputText
          v-model="input"
          v-bind="$attrs"
        />

        <div class="row q-gutter-sm justify-end">
          <BaseButton
            flat
            :label="$t('global.cancel')"
            @click="$emit('close')"
          />
          <BaseButton
            color="primary"
            :label="$t('global.save')"
            type="submit"
          />
        </div>
      </div>
    </FormWrapper>
  </Modal>
</template>

<script>
import { BaseButton, FormWrapper, InputText } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "InputModal",
  components: {
    Modal,
    BaseButton,
    FormWrapper,
    InputText,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [Number, String],
      default: "",
    },
  },
  emits: ["close", "submit"],
  data() {
    return {
      input: this.modelValue,
    };
  },
  methods: {
    onSubmit() {
      this.$emit("submit", this.input);
    },
  },
};
</script>
